import type { FC, PropsWithChildren } from 'react'
import { useRundownPermission } from '../lib/use-rundown-permission'
import type { RundownPermission } from '~shared/types'

type PermissionsGuardProps = {
  permission: RundownPermission
}

export const RundownPermissionGuard: FC<
  PropsWithChildren<PermissionsGuardProps>
> = ({ permission, children }) => {
  const hasPermission = useRundownPermission({ permission })

  if (hasPermission) return children

  return null
}
